import { addressFrag } from './common.types';

export const ePrescriptionMedicationFrag = `
    id
    code
    ePrescriptionId
    amount
    dosing
    paymentByEmployer
    pCheck
`;

export const ePrescriptionMagistraliterIngredientFrag = `
    id
    magistraliterId
    name
    amount
    unit
    substanceCode
    registeredMedicationCode
`;

export const ePrescriptionMagistraliterFrag = `
    id
    ePrescriptionId
    name
    preparationProcedure
    administrationRoute
    form
    amount
    dosing
    paymentByEmployer
    pCheck
    ingredients {
        ${ePrescriptionMagistraliterIngredientFrag}
    }
`;

export const ePrescriptionMagistraliterTemplateGridFrag = `
    id
    name
    form
    administrationRoute
`;

export const ePrescriptionMagistraliterTemplateFrag = `
    ${ePrescriptionMagistraliterTemplateGridFrag}
    preparationProcedure
    amount
    dosing
    paymentByEmployer
    pCheck
    ingredients {
        id
        templateId
        name
        amount
        unit
        substanceCode
        registeredMedicationCode
    }
`;

export const ePrescriptionFrag = `
    id
    issuedAt
    validTo
    address {
        ${addressFrag}
    }
    note
    suklId
    workId
    status
    doctorId
    notificationType
    itemType
    diagnosis
`;

export const ePrescriptionWithMedicationsFrag = `
    ${ePrescriptionFrag}
    medications {
        ${ePrescriptionMedicationFrag}
    }
    magistraliter {
        ${ePrescriptionMagistraliterFrag}
    }
`;

export const ePrescriptionFullFrag = `
    ${ePrescriptionFrag}
    doctor {
        titleBeforeName
        name
        surname
        titleAfterName
        email
        icpOfDoctor
    }
    medications {
        ${ePrescriptionMedicationFrag}
    }
    magistraliter {
        ${ePrescriptionMagistraliterFrag}
    }
    work {
        id
        workType
        dateFrom
        serviceId
    }
`;
